module.exports = __webpack_public_path__ + "static/media/adminstrator.3e2c2f9b.png";